import React, { useEffect, useState, useRef } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import DeleteIcon from '@assets/icons/deleteIcon';
import OpenInEditorIcon from '@assets/icons/openInEditorIcon';
import { useLocation } from "react-router-dom";


const PreviewComponentOptions:React.FC<IProps> = (props) => {
  const [totalOffSetTop, setTotalOffSetTop]=useState(0);
  
  
  const useOutsideAlerter = (ref:any) => {
    useEffect(() => {
      const handleClickOutside = (event:any) => {
        if (ref.current && !ref.current.contains(event.target)) {
          props.setOpen(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const optionsRef = useRef(null);
  useOutsideAlerter(optionsRef);

  useEffect(() => {
    if(optionsRef && optionsRef.current){
      let element: any = optionsRef.current
      if (location.pathname==="/brand-library") {
        let offsetTop = 0;
        while (element && !(element.id as string).startsWith("preview-component-")) {
          element = element.parentElement;
        }
        if (element && element.offsetTop) {
          offsetTop = element.offsetTop;
        }
        setTotalOffSetTop(offsetTop);
      }
    }
  }, [optionsRef]);

  const handleEditBrand = () => {
    props.onActions("EDITBRAND");
    props.setOpen(false);
  }

  const handleDelete = () => {
    props.onActions("DELETEBRAND");
    props.setOpen(false);
  }

  let location = useLocation();

  const returnLeftValue = () => {
    var value = props.coordinates.x;
    if (location.pathname==="/brand-library") {
      if (props.coordinates.x > 1300) {
        value -= 735;
      }
      else {
        value -= 390;
      }
    }
    return value;
  }

  const returnTopValue = () => {
    var value = 0;
    if (location.pathname==="/brand-library") {
      value = totalOffSetTop - 120;
      if (props.coordinates.y < 500) {
        value += 105;
      }
    }
    return value;
  }



  return (
    <S.Root 
      ref={optionsRef}
      leftValue={`${returnLeftValue()}px`}
      topValue={`${returnTopValue()}px`}
      displayValue={totalOffSetTop === 0 ? `none` : `flex`}
    >
      {
        props.open &&
        <S.PopupContainer>
          <S.Title>
            {props.labels.name}
          </S.Title>
          <S.DescriptionContainer>
            {!props.dealerUser &&
            <S.Description>
              {props.labels.oem?"Oem":"Not Oem"}
            </S.Description>}
            {props.labels.organization &&
            <S.Description>
              {`Organization: ${props.labels.organization}`}
            </S.Description>}
            <S.Description>
              {`Created: ${props.labels.createdDate} by ${props.labels.userName}`}
            </S.Description>
            <S.Description>
              {`Last Edited: ${props.labels.lastEditedDate}`}
            </S.Description>
          </S.DescriptionContainer>
          <S.TopOptionsContainer>
            <S.OptionContainer
              onClick={handleEditBrand}
            >
              <S.OptionIconContainer>
                <OpenInEditorIcon />
              </S.OptionIconContainer>
              <S.OptionText>
                {`Edit Brand`}
              </S.OptionText>
            </S.OptionContainer>                   
          </S.TopOptionsContainer>
          <S.Divider />
          <S.BottomOptionsContainer>
            <S.OptionContainer
              onClick={handleDelete}
            >
              <S.OptionIconContainer>
                <DeleteIcon />
              </S.OptionIconContainer>
              <S.OptionText>
                {`Delete Brand`}
              </S.OptionText>
            </S.OptionContainer>
          </S.BottomOptionsContainer>
        </S.PopupContainer>
      }
    </S.Root>
  );
}

export default PreviewComponentOptions;